import React, { useState, useEffect, useContext } from "react";
import ReactPaginate from "react-paginate";
import Product from "../../home/Products/Product";
import {
  paginationItems,
  paginationItems2,
  paginationItems3,
  paginationMeta,
  paginationMeta2,
  paginationMeta3,
  loadOffer,
  loadProducts,
  loadNews,
} from "../../../constants/products";
import { addEvent } from "../../../constants/config";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addToCart } from "../../../redux/orebiSlice";
import ProductTable from "./ProductTable";
import { UserConfigContext } from "../../../context/UserConfigContext";

const Items = ({ products, viewType, hoveredItem, setHoveredItem }) => {
  const [quantities, setQuantities] = useState({});
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const loggedUserData = JSON.parse(localStorage.getItem("user")) || {};
  const { id_usuario = "", nrocli = "" } = loggedUserData?.data?.cliente || {};
  const { ip = "", dispositivo = "", tipo_dispositivo = "" } = loggedUserData?.data || {};

  const handleQuantityChange = (codigo, value) => {
    setQuantities((prev) => ({ ...prev, [codigo]: Number(value) }));
  };

  const handleAddToCart = (item, quantityToAdd) => {
    dispatch(addToCart({ ...item, quantity: Number(quantityToAdd) }));
    //addEvent(id_usuario, nrocli, ip, dispositivo, tipo_dispositivo, 4, "", item.codigo, quantityToAdd);
  };

  const handleImageClick = (item) => {
    const cod = item.codigo.replace(/\//g, "|");
    navigate(`/product/${cod}`, { state: { item } });
  };

  if (products.length === 0) {
    return <div className="text-center text-lg text-gray-600 mt-8">No se encontraron resultados.</div>;
  }

  return viewType === "table" ? (
    <ProductTable
      products={products}
      hoveredItem={hoveredItem}
      setHoveredItem={setHoveredItem}
      handleImageClick={handleImageClick}
      handleQuantityChange={handleQuantityChange}
      handleAddToCart={handleAddToCart}
      quantities={quantities}
    />
  ) : (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-10">
      {products.map((item) => (
        <div key={item.codigo} className="w-full">
          <Product
            img={item.img}
            codigo={item.codigo}
            Descripcion={item.Descripcion}
            PrecioLista={item.PrecioLista}
            PrecioOferta={item.PrecioOferta}
            favorito={item.favorito}
          />
        </div>
      ))}
    </div>
  );
};

const Pagination = () => {
  const [products, setProducts] = useState([]);
  const [pageNumber, setPageNumber] = useState(() => parseInt(sessionStorage.getItem("pageNumber")) || 1);
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [selectedGroup, setSelectedGroup] = useState(() => sessionStorage.getItem("selectedGroup") || "0");
  const [selectedBrand, setSelectedBrand] = useState(() => sessionStorage.getItem("selectedBrand") || "0");
  const [selectedCondicion, setSelectedCondicion] = useState(() => sessionStorage.getItem("selectedCondicion") || "0");
  const [selectedType, setSelectedType] = useState(() => sessionStorage.getItem("selectedType") || "0");
  const [searchTerm, setSearchTerm] = useState(() => sessionStorage.getItem("searchTerm") || "");
  const [viewType, setViewType] = useState("table");
  const [hoveredItem, setHoveredItem] = useState(null);
  const [loading, setLoading] = useState(false);

  const location = useLocation();
  const { config1, config2 } = useContext(UserConfigContext);
  const filtros = config1?.filtros || {};
  const vista_ecommerce = localStorage.getItem('vista_ecommerce');
  console.log(vista_ecommerce)
  
  useEffect(() => {
    if (location.pathname === "/Offer" || location.pathname === "/News") {
      setViewType("table");
    } else if (config2?.vista?.vista) {
      if (vista_ecommerce !== ''){
        setViewType(vista_ecommerce);
      }else {
        setViewType(config2.vista.vista);
      }
      //console.log(config2.vista);
    }
  }, [config2, location.pathname]);

  const getLoadFunction = () => {
    switch (location.pathname) {
      case "/News":
        return loadNews;
      case "/Offer":
        return loadOffer;
      default:
        return loadProducts;
    }
  };

  const fetchProducts = async () => {
    setLoading(true);
    try {
      const loadFunction = getLoadFunction();
      await loadFunction(pageNumber, itemsPerPage, searchTerm, selectedGroup, selectedType, selectedBrand, selectedCondicion);
      const data =
        location.pathname === "/News"
          ? paginationItems2
          : location.pathname === "/Offer"
          ? paginationItems3
          : paginationItems;
      setProducts(data);
    } catch (error) {
      console.error("Error loading products:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchProducts();
    }, 400);
  
    return () => clearTimeout(handler);
  }, [
    pageNumber,
    itemsPerPage,
    searchTerm,
    selectedGroup,
    selectedType,
    selectedBrand,
    selectedCondicion,
    location.pathname,
  ]);
  
  const handleSearchTermChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    sessionStorage.setItem("searchTerm", value);
  };

  const handleSelectChange = (setter, key) => (e) => {
    const value = e.target.value;
    setter(value);
    sessionStorage.setItem(key, value);
    setPageNumber(1);
    sessionStorage.setItem("pageNumber", 1);
  };

  const handlePageChange = ({ selected }) => {
    const newPage = selected + 1;
    setPageNumber(newPage);
    sessionStorage.setItem("pageNumber", newPage);
  };

  const pageCount =
    location.pathname === "/News"
      ? paginationMeta2.totalPages
      : location.pathname === "/Offer"
      ? paginationMeta3.totalPages
      : paginationMeta.totalPages;

  return (
    <>
      <div className="p-5">
        <div className="flex mb-4">
          <input
            type="text"
            placeholder="Buscar productos..."
            value={searchTerm}
            onChange={handleSearchTermChange}
            onBlur={() => {
              if (searchTerm.length >= 3) {
                const user = JSON.parse(localStorage.getItem("user")) || {};
                const { id_usuario = "", nrocli = "" } = user?.data?.cliente || {};
                const { ip = "", dispositivo = "", tipo_dispositivo = "" } = user?.data || {};
                //addEvent(id_usuario, nrocli, ip, dispositivo, tipo_dispositivo, 2, "", "", 1, searchTerm);
              }
            }}
            className="flex-grow border border-gray-300 rounded p-2"
          />
          <select
            value={itemsPerPage}
            onChange={(e) => setItemsPerPage(Number(e.target.value))}
            className="ml-2 border border-gray-300 rounded p-2"
          >
            <option value={50}>50</option>
            <option value={75}>75</option>
            <option value={100}>100</option>
            <option value={-1}>Todos</option>
          </select>
          <select
            value={viewType}
            onChange={(e) => setViewType(e.target.value)}
            className="ml-2 border border-gray-300 rounded p-2"
          >
            <option value="grid">Grid</option>
            <option value="table">Tabla</option>
          </select>
        </div>

        <div className="flex mb-4">
          {filtros?.condicion === 1 && (
            <select
              value={selectedCondicion}
              onChange={handleSelectChange(setSelectedCondicion, "selectedCondicion")}
              className="mr-2 border border-gray-300 rounded p-2 w-full"
            >
              <option value="0">Seleccionar Condición</option>
              {config1.atributos.map((tipo) => (
                <option key={tipo.codigo} value={tipo.codigo}>
                  {tipo.descripcion}
                </option>
              ))}
            </select>
          )}
          {filtros?.tipos === 1 && (
            <select
              value={selectedType}
              onChange={handleSelectChange(setSelectedType, "selectedType")}
              className="mr-2 border border-gray-300 rounded p-2 w-full"
            >
              <option value="0">Seleccionar Tipo</option>
              {config1.tipos.map((tipo) => (
                <option key={tipo.codigo} value={tipo.codigo}>
                  {tipo.descripcion}
                </option>
              ))}
            </select>
          )}            
          {filtros?.grupos === 1 && (
            <select
              value={selectedGroup}
              onChange={handleSelectChange(setSelectedGroup, "selectedGroup")}
              className="mr-2 border border-gray-300 rounded p-2 w-full"
            >
              <option value="0">Seleccionar Grupo</option>
              {config1.grupos.map((grupo) => (
                <option key={grupo.codigo} value={grupo.codigo}>
                  {grupo.descripcion}
                </option>
              ))}
            </select>
          )}
          {filtros?.marcas === 1 && (
            <select
              value={selectedBrand}
              onChange={handleSelectChange(setSelectedBrand, "selectedBrand")}
              className="mr-2 border border-gray-300 rounded p-2 w-full"
            >
              <option value="0">Seleccionar Marca</option>
              {config1.marcas.map((marca) => (
                <option key={marca.clave_id} value={marca.clave_id}>
                  {marca.descripcion}
                </option>
              ))}
            </select>
          )}
        </div>

        {loading ? (
          <div className="text-center text-xl my-4">Cargando...</div>
        ) : (
          <Items
            products={products}
            viewType={viewType}
            hoveredItem={hoveredItem}
            setHoveredItem={setHoveredItem}
          />
        )}

        {pageCount > 1 && (
          <ReactPaginate
            nextLabel="Siguiente"
            previousLabel="Anterior"
            onPageChange={handlePageChange}
            pageCount={pageCount}
            forcePage={pageNumber - 1}
            containerClassName="flex justify-center mt-4"
            pageClassName="mx-1 px-3 py-1 border border-gray-300 rounded"
            activeClassName="bg-blue-500 text-white"
          />
        )}
      </div>
    </>
  );
};

export default Pagination;
